export default __webpack_public_path__ + "static/media/fotenie-smaskotom.57f707d0.svg";